<template>
  <v-dialog v-model="show" persistent width="900">
    <v-card :loading="loading">
      <v-card-title>Item transaction error for {{name}}</v-card-title>
      <v-divider/>
      <v-card-text>
        <div class="error--text pa-2 text-body-1">{{error.message}}</div>

        <v-simple-table fixed-header height="300">
          <thead>
            <tr>
              <th width="20%">Date</th>
              <th width="40%">Transaction</th>
              <th width="20%" class="text-right">{{info.quantity ? trackUnits : '$'}}</th>
              <th width="20%" class="text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(line,index) in lines" :class="{'font-weight-bold':index===1, 'error--text':line.balance<0}">
              <td>{{line.date | formatDateTime}}</td>
              <td>{{line.description}}</td>
              <td class="text-right">{{line.amount | number(precision)}}</td>
              <td class="text-right">{{line.balance | number(precision)}}</td>
            </tr>
          </tbody>
        </v-simple-table>

      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show=false;$emit('done')">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {add,format} from 'date-fns';

export default {
  name: 'InventoryItemsTransactionError',
  data() {
    return {
      show: true,
      name: '',
      precision: 0,
      trackUnits: '',
      lines: []
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    info() {
      return this.error.info;
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query InventoryItemsTransactionError($id:ID!,$asof:DateTime!,$lot:String) {
                                            item(id:$id) {
                                              name,trackUnits,precision,sites(asof:$asof,lot:$lot) {quantity,value}
                                              transactions2(first:100, sortKey:"date", reverse:false,
                                                            filters:[{field:"from", comparator:ge, value:"${this.info.transactionDate.substring(0,10)}"},
                                                                    {field:"to", comparator:le, value:"${this.info.errorDate.substring(0,10)}"},
                                                                    {field:"siteId", comparator:eq, value:"${this.info.siteId}"},
                                                                    {field:"lot", comparator:eq, value:"${this.info.lot}"}]) {
                                                  edges {
                                                    node {
                                                      refId,date,description,quantity,value
                                                    }
                                                  }
                                              }
                                            }
                                          }`,
                                        {id:this.info.itemId,
                                          asof:format(add(new Date(this.info.transactionDate), {seconds:-1}), 'yyyy-MM-dd HH:mm:ss'),
                                          lot:this.info.lot});
    if (!results.error) {
      const item = results.data.item;
      this.name = item.name;
      this.precision = this.info.quantity ? item.precision : 2;
      this.trackUnits = item.trackUnits;
      let balance = item.sites.length ? item.sites[0][this.info.quantity ? 'quantity' : 'value'] : 0;
      this.lines.push({description:'Balance forward',balance});
      balance += this.info.amount;
      this.lines.push({date:this.info.transactionDate,description:'PROPOSED TRANSACTION',amount:this.info.amount,balance});
      for (const edge of item.transactions2.edges) {
        const transaction = edge.node;
        if (transaction.refId === this.info.transactionId || transaction.date < this.info.transactionDate)
          continue;
        const amount = this.info.quantity ? transaction.quantity : transaction.value;
        balance += amount;
        this.lines.push({date:transaction.date,description:transaction.description,amount,balance});
      }

    }
    this.loading = false;
  }
}
</script>